import {
  request,
  METHOD
} from '@/utils/request.js'


// 开云台
export function startHwpTC(data) {
  return request(
    '/web/admin/deviceInfo/startHwpTC',
    METHOD.POST,
    data
  )
}
// 关云台
export function endHwpTC(data) {
  return request(
    '/web/admin/deviceInfo/endHwpTC',
    METHOD.POST,
    data
  )
}
// 调整云台
export function updateHwpYT(data) {
  return request(
    '/web/admin/deviceInfo/updateHwpYT',
    METHOD.POST,
    data
  )
}
// 预置点
export function selectHwpYTPoint(data) {
  return request(
    '/web/admin/deviceInfo/selectHwpYTPoint',
    METHOD.POST,
    data
  )
}
// 获取mqtt云台配置
export function selectConfigurationByHwpQd(data) {
  return request(
    '/web/admin/deviceInfo/selectConfigurationByHwpQd',
    METHOD.GET,
    data
  )
}
// 自动获取划线
export function getAutoLine(data) {
  return request(
    '/web/admin/deviceInfo/autoLine',
    METHOD.POST,
    data
  )
}
// 修改划线
export function updateLine(data) {
  return request(
    '/web/admin/deviceInfo/updateLine',
    METHOD.POST,
    data
  )
}
